module.exports = __webpack_public_path__ + "img/empty_lesson_after.a79b17fd.png";